import { AppState } from "../../../redux-configuration/AppState";

export const editCompanyLoadingSelector = (appState: AppState): boolean => appState.company.editCompany.loading
export const editCompanyErrorSelector = (appState: AppState): string | undefined => appState.company.editCompany.error
export const editCompanySuccessSelector = (appState: AppState): boolean | null => appState.company.editCompany.success
